import React, { Component } from 'react';
import Title from './Title';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import Badge from '@mui/material/Badge';

function preventDefault(event) {
  event.preventDefault();
}

class BIMDataList extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  render() {
    return (
      <React.Fragment>
        <Title>BIM Data Report</Title>
        <List>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <Badge badgeContent={22} color="primary">
                  <ViewInArIcon />
                </Badge>
              </ListItemIcon>
              <ListItemText primary="Structures" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <Badge badgeContent={86} color="primary">
                  <ViewInArIcon />
                </Badge>
              </ListItemIcon>
              <ListItemText primary="Bus" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <Badge badgeContent={12} color="success">
                  <ViewInArIcon />
                </Badge>
              </ListItemIcon>
              <ListItemText primary="Major Equipment" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <Badge badgeContent={245} color="error">
                  <ViewInArIcon />
                </Badge>
              </ListItemIcon>
              <ListItemText primary="Uncategorized" />
            </ListItemButton>
          </ListItem>

        </List>
      </React.Fragment>
    );
  }
}

export default BIMDataList;
